module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-11 col-sm-4 alert open alert-with-icon",
    class: [_vm.verticalAlign, _vm.horizontalAlign, _vm.alertType],
    style: (_vm.customPosition),
    attrs: {
      "data-notify": "container",
      "role": "alert",
      "data-notify-position": "top-center"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "data-notify": "dismiss"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×\n  ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-notify": "icon"
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('span', {
    attrs: {
      "data-notify": "message"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4679d3d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/NotificationPlugin/Notification.vue
// module id = 160
// module chunks = 2